import {DependencyList, useRef} from 'react';

import {isShallowEqual} from '../../../../helpers/reselectHelpers';
import {AsyncTableSource, AsyncTableSourceOptions} from '../source/asyncTableSource';

/*
 * Props.
 */

interface AsyncTableSourceState {
  source: AsyncTableSource;
  dependencies: DependencyList;
}

/*
 * Hook.
 */

export function useAsyncTableSource(options: AsyncTableSourceOptions, dependencies: DependencyList) {
  const tableSourceStateRef = useRef<AsyncTableSourceState>();

  const fetcherRef = useRef(options.fetcher);
  fetcherRef.current = options.fetcher;

  const onSortChangeRef = useRef(options.onSortChange);
  onSortChangeRef.current = options.onSortChange;

  const onResetRef = useRef(options.onReset);
  onResetRef.current = options.onReset;

  if (
    !tableSourceStateRef.current ||
    !isShallowEqual(tableSourceStateRef.current.dependencies, dependencies)
  ) {
    tableSourceStateRef.current = {
      source: new AsyncTableSource({
        fetcher: (value) => fetcherRef.current(value),
        onSortChange: (col) => {
          if (onSortChangeRef.current) {
            onSortChangeRef.current(col);
          }
        },
        onReset: async () => {
          if (onResetRef.current) {
            await onResetRef.current();
          }
        },
      }),
      dependencies,
    };
  }

  return tableSourceStateRef.current.source;
}
